





































































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { defaultSimpleBibliographyReal, SimpleBibliographyReal } from '@/api'
import IconBibliography from '@/components/molecules/IconBibliography/IconBibliography.vue'
import { CollectionFlag, Prefix } from '@/types'

@Component({
  components: { IconBibliography }
})
export default class UpdateMemoBibliographyInfo extends ComponentVue {
  @Prop({
    type: Object,
    default: defaultSimpleBibliographyReal
  })
  item!: SimpleBibliographyReal

  get bibliographyId() {
    if (this.item.bibliographyId < 1) {
      return ''
    }
    return (
      this.item.prefix + this.item.bibliographyId.toString().padStart(10, '0')
    )
  }

  get bibliographySetId() {
    if (this.item.bibliographySetId === null) {
      return ''
    }
    return Prefix.Set + this.item.bibliographySetId.toString().padStart(10, '0')
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }
}
